import React, { useState } from "react";
import { InputText } from "..";
import useDebounce from "../../helpers/debounce";

function InputDebounce({
  value,
  onChange,
  disabled = false,
  onKeyPress,
  InputProps,
  placeholder,
  style,
  label = "",
  debounceTime = 500,
  ...props
}) {
  const [displayValue, setDisplayValue] = useState(value);
  const debounceChange = useDebounce(onChange, debounceTime);

  function handleChange(event) {
    setDisplayValue(event.target.value);
    debounceChange(event.target.value);
  }

  return (
    <InputText
      {...props}
      label={label}
      style={style}
      disabled={disabled}
      value={displayValue || value}
      onChange={handleChange}
      onKeyPress={onKeyPress}
      fullWidth
      InputProps={InputProps}
      placeholder={placeholder}
    />
  );
}

export default InputDebounce;
